import { ScorecardReport } from '../../components/ScorecardReport';

/**
 * The CS scorecard — the Centralized Services and Automation items in the
 * scorecard library, with the figures Autotask can give
 * (api/src/lib/csScorecard.ts). The report itself is shared with the NOC
 * page: components/ScorecardReport.tsx.
 */
export function CsScorecard() {
  return (
    <ScorecardReport
      path="/cs/scorecard"
      team="Centralized Services and Automation"
      filePrefix="cs-scorecard"
      caption={(from, to) =>
        `Figures are live from Autotask: tickets completed ${from} to ${to}, plus open tickets, devices and onboarding projects as of now.`
      }
    />
  );
}
